import { render, staticRenderFns } from "./EmployeesImport.vue?vue&type=template&id=97d95b36&scoped=true&"
import script from "./EmployeesImport.vue?vue&type=script&lang=js&"
export * from "./EmployeesImport.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesImport.vue?vue&type=style&index=0&id=97d95b36&prod&scoped=true&lang=scss&"
import style1 from "./EmployeesImport.vue?vue&type=style&index=1&id=97d95b36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d95b36",
  null
  
)

export default component.exports